import {
    fetchGroupsSummary,
    fetchVerificationTypes
} from '@components/Packages/Recipients/recipientsSlice';

export default function fetchCommonRefs({
    store, headers, baseUrl, options
}) {
    return [
        store.dispatch(fetchGroupsSummary({headers, baseUrl, options})),
        store.dispatch(fetchVerificationTypes({headers, baseUrl, options}))
    ];
}
